import { Component, ElementRef, HostListener, QueryList, ViewChildren } from '@angular/core';

import { ReportService } from '../../services/report.service';
import { BaseReportComponent } from '../reports/base-report.component';
import { SelectItem, Tooltip } from 'primeng';
import { customCalendarCellClass } from '../../utils/calendar-utils';
import { BBWTMessageService, UserService } from '../../services';

@Component({
  selector: 'declined-expenses-report',
  styleUrls: ['./declined-expenses-report.component.scss'],
  templateUrl: './declined-expenses-report.component.html',
})
export class DeclinedExpensesReportComponent extends BaseReportComponent<any, any, any> {
  constructor(
    private _eref: ElementRef,
    reportService: ReportService<any, any>,
    private messageService: BBWTMessageService,
    private userService: UserService,
  ) {
    super(reportService, false);
    reportService.url = '/api/report/declined-expenses-report';
  }

  @ViewChildren(Tooltip) tooltips!: QueryList<Tooltip>;

  private toolTip: Tooltip;

  public isPOAD: boolean;

  public declinedReasons: SelectItem[] = [];
  public requestedUsers: SelectItem[] = [];
  public approvedDeclinedUsers: SelectItem[] = [];
  public chargeTypes: SelectItem[] = [];
  public requestInfoReasons: SelectItem[] = [];
  public statusOptions: SelectItem[] = [];
  public supplierOptions: SelectItem[] = [];

  public jobClosedBetweenSelection: any;
  public expenseReviewedBetweenSelection: any;
  public expenseCompletedBetweenSelection: any;

  public backfillDialogVisible: boolean = false;

  protected readonly customCalendarCellClass = customCalendarCellClass;

  public callbackLoadFilterParam() {
    this.declinedReasons = this.filterParam?.declinedReasons || [];
    this.requestedUsers = this.filterParam?.requestedUsers || [];
    this.approvedDeclinedUsers = this.filterParam?.approvedDeclinedUsers || [];
    this.chargeTypes = this.filterParam?.additionalChargeTypes || [];
    this.requestInfoReasons = this.filterParam?.requestInfoReasons || [];
    this.statusOptions = this.filterParam?.additionalChargeStatuses || [];
    this.supplierOptions = this.filterParam?.suppliers || [];
  }

  openToolTip(id) {
    this.toolTip = this.tooltips.find((tooltip) => tooltip.el.nativeElement.id === id);
    this.toolTip.activate();
  }

  ngOnInit() {
    super.ngOnInit();
    void this.setIsPOAD();
  }

  async setIsPOAD() {
    this.isPOAD = await this.userService.isUserInRole('POAD');
  }

  handleDisplayEmailBodyChange(e) {
    this.filterVal.filters.displayEmailBody.value = e.checked;
  }

  public backfillFromDate: string;
  public backfillRunning: boolean;

  // Listen for click events on the document
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.toolTip?.el?.nativeElement?.contains(event.target)) {
      // If the click is outside the element, hide the tooltip
      this.toolTip?.hide();
    }
  }

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 20,
      sortField: '',
      sortOrder: 1,
      filters: {
        expenseReviewFrom: {},
        expenseReviewTo: {},
        expenseCompletedFrom: {},
        expenseCompletedTo: {},
        jobClosedFrom: {},
        jobClosedTo: {},
        expenseChargeTypes: { value: null },
        jobNumber: { value: null },
        declinedReasons: { value: null },
        approvedDeclinedUsers: { value: null },
        requestedUsers: { value: null },
        requestInfoReasons: { value: null },
        additionalChargeStatus: { value: null },
        expenseAmount: {},
        expenseDays: { value: 150 },
        displayEmailBody: { value: true },
        suppliers: { value: null },
      },
    };
  }

  navigateToJobScreen(jobId: number): void {
    const url = `app/jobscreen/${jobId}`;
    window.open(url, '_blank');
  }

  setJobClosedBetweenDates(): void {
    if (this.jobClosedBetweenSelection && this.jobClosedBetweenSelection.length === 2) {
      const startDate = this.jobClosedBetweenSelection[0];
      const endDate = this.jobClosedBetweenSelection[1];

      this.filterVal.filters.jobClosedFrom.value = startDate;
      this.filterVal.filters.jobClosedTo.value = endDate;
    }
  }

  setExpenseReviewedBetweenDates(): void {
    if (this.expenseReviewedBetweenSelection && this.expenseReviewedBetweenSelection.length === 2) {
      const startDate = this.expenseReviewedBetweenSelection[0];
      const endDate = this.expenseReviewedBetweenSelection[1];

      this.filterVal.filters.expenseReviewFrom.value = startDate;
      this.filterVal.filters.expenseReviewTo.value = endDate;
    }
  }

  setExpenseCompletedBetweenDates(): void {
    if (
      this.expenseCompletedBetweenSelection &&
      this.expenseCompletedBetweenSelection.length === 2
    ) {
      const startDate = this.expenseCompletedBetweenSelection[0];
      const endDate = this.expenseCompletedBetweenSelection[1];

      this.filterVal.filters.expenseCompletedFrom.value = startDate;
      this.filterVal.filters.expenseCompletedTo.value = endDate;
    }
  }

  async backfillReport() {
    this.backfillRunning = true;
    try {
      await this.reportService.backfillExpensesReport(this.backfillFromDate);
      this.backfillDialogVisible = false;
      this.messageService.ShowSuccess('Report backfill enqueuing successfully', '');
    } catch (e) {
      console.error(e);
      this.messageService.ShowError('Error enqueuing backfilling report', '');
    } finally {
      this.backfillRunning = false;
    }
  }
}
